//export const BASE_URL = 'https://marsiya-exercise-tracker.herokuapp.com';

// export const BASE_URL = 'https://agile-gray-woolens.cyclic.cloud';

// export const BASE_URL = 'http://localhost:5000';
export const BASE_URL = 'https://actual-patti-marsiya-issah-efd18069.koyeb.app'
